import { render, staticRenderFns } from "./myinfo-id-no.vue?vue&type=template&id=61886fe2&"
import script from "./myinfo-id-no.vue?vue&type=script&lang=js&"
export * from "./myinfo-id-no.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports